import { ReactNode } from "react";
import cx from "classnames";

import BaseAction, { BaseActionProps } from "ds/components/BaseAction";

type StepperStepProps = BaseActionProps & {
  children: ReactNode;
  active?: boolean;
  onClick?: () => void;
};

import styles from "./styles.module.css";

const StepperStep = ({ active, children, disabled, onClick }: StepperStepProps) => {
  return (
    <BaseAction
      className={cx(styles.wrapper, active && styles.active)}
      disabled={disabled}
      onClick={onClick}
    >
      <div className={styles.icon} aria-hidden />
      <span className={styles.label}>{children}</span>
    </BaseAction>
  );
};

StepperStep.displayName = "DS.Stepper.Step";

export default StepperStep;
